import { render, staticRenderFns } from "./PostDetail.vue?vue&type=template&id=046bf436&scoped=true"
import script from "./PostDetail.vue?vue&type=script&lang=js"
export * from "./PostDetail.vue?vue&type=script&lang=js"
import style0 from "./PostDetail.vue?vue&type=style&index=0&id=046bf436&prod&lang=css"
import style1 from "./PostDetail.vue?vue&type=style&index=1&id=046bf436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046bf436",
  null
  
)

export default component.exports